export default __webpack_public_path__ + "static/media/Tri-Glave of the Demon's Roar.6ee182bf.jpg";